export const API_URL = 'https://chat.vcurd.co.in/api';
// export const API_URL = 'http://localhost:3001/api';
